__turbopack_context__.v({
  "container": "bDeVYG_container",
  "title": "bDeVYG_title",
});
